import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appSSNFormatter]'
})
export class SSNFormatterDirective {
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event) {
    let input = this.el.nativeElement.value.replace(/\D/g, ''); 

    // Allow already masked value "XXX-XX-"
    if (this.el.nativeElement.value.startsWith('XXX-XX-')) {
      this.control.control?.setValue(this.el.nativeElement.value, { emitEvent: false });
      return;
    }

    if (input.length > 9) {
      input = input.substring(0, 9); 
    }

    let formatted = '';
    if (input.length <= 3) {
      formatted = input;
    } else if (input.length <= 5) {
      formatted = `${input.slice(0, 3)}-${input.slice(3)}`;
    } else {
      formatted = `${input.slice(0, 3)}-${input.slice(3, 5)}-${input.slice(5)}`;
    }

    this.el.nativeElement.value = formatted;
    this.control.control?.setValue(formatted, { emitEvent: false });
  }
}
